
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function FoundersPage() {
  const founders = [
    {
      name: "Carlos A. López Galan",
      title: "Co-Founder & Managing Partner",
      image: "https://public.readdy.ai/ai/img_res/dbb71c48a995b1f9b3e82cb042439387.jpg",
      bio: "Executive advisor and strategic investor with more than 35 years of experience in Latin America's financial sector. Carlos has held senior leadership roles across the Banco Santander Group—including CFO responsibilities in both Brazil and Mexico—where he oversaw regional expansion, capital strategy and integration in dynamic emerging-markets environments.",
      experience: "In his role as CFO of Santander Brasil, Carlos directed large-scale financial operations, investment pipelines and regulatory compliance across one of Latin America's most complex banking markets. With deep exposure to fund structuring, enterprise growth and cross-border deals, he has invested in and supported Latin American companies from early-stage through growth phases.",
      approach: "Bringing the discipline of institutional banking together with the agility of venture-backed enterprises, Carlos now partners with founders and funds to build resilient, scalable businesses—adding strategic capital, financial structuring, and regional insight across Europe and Latin America.",
      linkedin: "https://www.linkedin.com/in/carlos-a-l%C3%B3pez-galan-074427108/"
    },
    {
      name: "Roberto Paulus Lopez",
      title: "Co-Founder & Managing Partner",
      image: "https://readdy.ai/api/search-image?query=Professional%20executive%20portrait%20of%20a%20sophisticated%20Latin%20American%20business%20leader%20in%20his%2040s%2C%20wearing%20a%20charcoal%20gray%20business%20suit%20with%20crisp%20white%20shirt%2C%20confident%20and%20approachable%20expression%2C%20modern%20office%20environment%20with%20natural%20lighting%2C%20executive%20headshot%20photography%2C%20polished%20and%20professional%20appearance&width=400&height=500&seq=roberto-paulus&orientation=portrait",
      bio: "Seasoned operations and growth executive with deep expertise in Latin America and cross-border expansion. As COO for Latin America at Bank of America, Roberto led multisector operational teams, crafted regional strategy, and scaled business performance across emerging markets.",
      experience: "Over the past decade he has also collaborated with multiple venture funds and early-stage startups of all sizes, helping them hone product-market fit, structure go-to-market strategies and build operational discipline. Leveraging a rare combination of large-bank rigor and startup agility, he partners with founders to design scalable business models, optimise financial operations, and successfully navigate expansion into Latin America.",
      approach: "Whether guiding internationalisation efforts, managing regulatory and operational complexity, or deploying capital with hands‑on growth support, Roberto brings leadership, strategic insight and a global mindset to ventures bridging Europe, LatAm and beyond.",
      linkedin: "https://www.linkedin.com/in/roberto-paulus-lopez-29393640/"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-6 text-left md:text-center" style={{ fontFamily: '"Playfair Display", serif' }}>
              Meet Our Founders
            </h1>
            <p className="text-base md:text-xl text-white leading-relaxed">
              Decades of combined experience in Latin American finance, operations, and venture capital. 
              Our founders bring institutional expertise and entrepreneurial vision to every investment.
            </p>
          </div>
        </div>
      </section>

      {/* Founders Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="space-y-20">
            {founders.map((founder, index) => (
              <div key={founder.name} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full max-w-md mx-auto rounded-2xl shadow-xl object-cover object-top"
                  />
                </div>
                
                <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                  <div className="max-w-xl">
                    <h2 className="text-xl md:text-3xl font-bold text-slate-900 mb-2 text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                      {founder.name}
                    </h2>
                    <p className="text-base md:text-lg text-slate-600 mb-6 font-medium text-left">
                      {founder.title}
                    </p>
                    
                    <div className="space-y-6">
                      <div>
                        <h3 className="text-base md:text-lg font-semibold text-slate-900 mb-2 text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                          Background
                        </h3>
                        <p className="text-sm md:text-base text-slate-700 leading-relaxed text-left">
                          {founder.bio}
                        </p>
                      </div>
                      
                      <div>
                        <h3 className="text-base md:text-lg font-semibold text-slate-900 mb-2 text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                          Experience
                        </h3>
                        <p className="text-sm md:text-base text-slate-700 leading-relaxed text-left">
                          {founder.experience}
                        </p>
                      </div>
                      
                      <div>
                        <h3 className="text-base md:text-lg font-semibold text-slate-900 mb-2 text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                          Investment Approach
                        </h3>
                        <p className="text-sm md:text-base text-slate-700 leading-relaxed text-left">
                          {founder.approach}
                        </p>
                      </div>
                      
                      <div className="pt-4">
                        <a
                          href={founder.linkedin}
                          className="inline-flex items-center px-6 py-3 bg-slate-900 text-white font-medium rounded-lg hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-linkedin-fill mr-2"></i>
                          Connect on LinkedIn
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-xl md:text-3xl font-bold text-white mb-4 md:mb-6 text-left md:text-center" style={{ fontFamily: '"Playfair Display", serif' }}>
            Partner with Visionary Leaders
          </h2>
          <p className="text-base md:text-xl text-slate-300 mb-8 max-w-3xl mx-auto">
            Our founders are actively seeking the next generation of European startups ready to expand into Latin America. 
            Let&apos;s discuss how we can support your growth journey.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/apply"
              className="inline-flex items-center px-8 py-4 bg-white text-slate-900 font-semibold rounded-lg hover:bg-slate-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Apply for Funding
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="/contact"
              className="inline-flex items-center px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-slate-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Schedule a Meeting
              <i className="ri-calendar-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
